module.exports = __webpack_public_path__ + "static/img/11.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/11.png
// module id = wT0g
// module chunks = 0